export const chunkErrorMessages: RegExp[] = [/Loading chunk [d]+ failed/];
